import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import DialogAplikasi from "./components/etams/DialogAplikasi";

import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { catatLemparLogin } from "@/lib/lemparLoginDiag";
import { ThemeProvider, useTheme } from "@/contexts/ThemeContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Panduan from "@/pages/Panduan";
import TanyaEtamsRekap from "@/pages/TanyaEtamsRekap";
import Hpp from "@/pages/Hpp";
import Laporan from "@/pages/Laporan";
import KpiKetepatan from "@/pages/laporan/KpiKetepatan";
import Analitik from "@/pages/laporan/Analitik";
import PapanKontrol from "@/pages/PapanKontrol";
import PapanKontrolAmbang from "@/pages/PapanKontrolAmbang";
import AuditLogs from "@/pages/AuditLogs";
import TinjauanDelegasi from "@/pages/TinjauanDelegasi";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Holidays from "@/pages/Holidays";
import DesignRequests from "@/pages/DesignRequests";
import DesignRequestCreate from "@/pages/DesignRequestCreate";
import DesignRequestDetail from "@/pages/DesignRequestDetail";
import PaymentsPending from "@/pages/PaymentsPending";
import FAWizard from "@/pages/FAWizard";
import FADetail from "@/pages/FADetail";
import FAList from "@/pages/FAList";
import FaLama from "@/pages/FaLama";
import DesignTasks from "@/pages/DesignTasks";
import DesignTaskDetail from "@/pages/DesignTaskDetail";
import MasterPriceGroups from "@/pages/MasterPriceGroups";
import MasterPriceListItems from "@/pages/MasterPriceListItems";
import MasterKategoriHarga from "@/pages/MasterKategoriHarga";
import MasterKategoriKomplain from "@/pages/MasterKategoriKomplain";
import MasterRekeningResmi from "@/pages/MasterRekeningResmi";
import MasterKanalWa from "@/pages/MasterKanalWa";
import MasterAlasan from "@/pages/MasterAlasan";
import MasterOpsiHarga from "@/pages/MasterOpsiHarga";
import MasterSizeSurcharge from "@/pages/MasterSizeSurcharge";
import MasterCollar from "@/pages/MasterCollar";
import MasterNotificationChannels from "@/pages/MasterNotificationChannels";
import MasterTimePackage from "@/pages/MasterTimePackage";
import MasterBonusPromo from "@/pages/MasterBonusPromo";
// K68 + K72 (23 Agustus 2026) — pengecualian SADAR terhadap K65 untuk SATU
// layar ini saja. Karena butuh FINANCE selain OWNER/KEPALA_CABANG, ia tidak
// bisa lewat splat /master/* (requireOwnerOrKepala seragam di
// masterRoutes.js) — rute statis sendiri, sama seperti keenam /master/...
// di atas, tapi dengan roles={SEWING_RATE_ROLES}. Lihat lib/roles.js.
import MasterSewingRates from "@/pages/MasterSewingRates";
// Satu-satunya rute ber-lazy-load di berkas ini, dan itu disengaja: ia PINTU
// MASUK layar master milik J2, bukan halaman biasa. Sesudah baris ini
// terpasang, J2 menambah layar cukup lewat frontend/src/routes/masterRoutes.js
// dan TIDAK PERNAH menyentuh App.js lagi sepanjang sprint (batas jalur poin 4,
// K5 — satu berkas hanya boleh disentuh satu jalur).
const MasterRoutesLoader = React.lazy(() => import("@/routes/MasterRoutesLoader"));
// Pintu masuk domain HR (J3). Sesudah baris ini + satu <Route> di bawah,
// layar HR baru cukup ditambahkan di frontend/src/routes/hrRoutes.js.
const HRRoutesLoader = React.lazy(() => import("@/routes/HRRoutesLoader"));
// RUANG PESANAN (W3 / K124) — layar CUSTOMER, satu-satunya permukaan di
// aplikasi ini yang dibuka orang di luar ETAMS. Code-split karena nol satu
// pun staf akan memuatnya, dan customer memuatnya di HP lewat data seluler.
const RuangPesanan = React.lazy(() => import("@/pages/RuangPesanan"));
const RuangPesananTim = React.lazy(() => import("@/pages/RuangPesananTim"));
import SpecialCustomers from "@/pages/SpecialCustomers";
import FocRequests from "@/pages/FocRequests";
import Receivables from "@/pages/Receivables";
import Refunds from "@/pages/Refunds";
import PdfArchive from "@/pages/PdfArchive";
import PapanKerja from "@/pages/PapanKerja";
import Personil from "@/pages/PersonilMatriks";
// K134 — kelompok HRD. SENGAJA di sini, bukan di routes/hrRoutes.js:
// sub-router /hr/* duduk di LUAR <Layout/> supaya layar kios bisa dibuka
// tanpa login dan tanpa menu. Layar ini justru butuh menu.
import HRJamMasuk from "@/pages/HRJamMasuk";
import HRRekapAbsensi from "@/pages/HRRekapAbsensi";
import HRKaryawan from "@/pages/HRKaryawan";
import BoronganSerahTerima from "@/pages/BoronganSerahTerima";
import SerahTerimaCustomer from "@/pages/SerahTerimaCustomer";
import TindakLanjutPesanan from "@/pages/TindakLanjutPesanan";
import BoronganRekapUpah from "@/pages/BoronganRekapUpah";
import Complaints from "@/pages/Complaints";
import Percakapan from "@/pages/Percakapan";
import KanalWhatsapp from "@/pages/KanalWhatsapp";
import TrackingPesanan from "@/pages/TrackingPesanan";
import PapanTV from "@/pages/PapanTV";
import WOList from "@/pages/WOList";
import WOCreate from "@/pages/WOCreate";
import WOUsulDraft from "@/pages/WOUsulDraft";
import WODetail from "@/pages/WODetail";
import InvMaterials from "@/pages/inventory/Materials";
import InvMaterialIssues from "@/pages/inventory/MaterialIssues";
import InvFinishedGoods from "@/pages/inventory/FinishedGoods";
import InvTransfers from "@/pages/inventory/Transfers";
import InvStockLedger from "@/pages/inventory/StockLedger";
import InvAdjustments from "@/pages/inventory/Adjustments";
import BarangBerkurang from "@/pages/inventory/BarangBerkurang";
import PindahBahan from "@/pages/inventory/PindahBahan";
import StokAwal from "@/pages/inventory/StokAwal";
import LaporanBalik from "@/pages/LaporanBalik";
import HRPengajuanIzin from "@/pages/HRPengajuanIzin";
import HRKoreksiAbsen from "@/pages/HRKoreksiAbsen";
import HRPayroll from "@/pages/HRPayroll";
import UangMasuk from "@/pages/UangMasuk";
import TelusurLot from "@/pages/inventory/TelusurLot";
import AlarmBahan from "@/pages/inventory/AlarmBahan";
import InvOpname from "@/pages/inventory/Opname";
import InvFGMovement from "@/pages/inventory/FGMovement";
import PurVendors from "@/pages/purchasing/Vendors";
import PurPRs from "@/pages/purchasing/PurchaseRequests";
import PurPRDetail from "@/pages/purchasing/PurchaseRequestDetail";
import PurPOs from "@/pages/purchasing/PurchaseOrders";
import PurPODetail from "@/pages/purchasing/PurchaseOrderDetail";
import PurReceiving from "@/pages/purchasing/Receiving";
import PurReturns from "@/pages/purchasing/VendorReturns";
import PurInvoices from "@/pages/purchasing/VendorInvoices";
import PurInvoiceDetail from "@/pages/purchasing/VendorInvoiceDetail";
import PurInvoiceCreate from "@/pages/purchasing/VendorInvoiceCreate";
import PurPayments from "@/pages/purchasing/VendorPayments";
import SpvReview from "@/pages/SpvReview";
import PurDPs from "@/pages/purchasing/VendorDPs";
import PurDPDetail from "@/pages/purchasing/VendorDPDetail";
// Aset & Maintenance (Tahap 4b-1, 16 Sep 2026). Rute cermin `aset_meta.RUTE`
// (`/aset`, `/aset/{id}`, `/aset/jadwal` sejak 4b-2, `/aset/laporan-bulanan`
// sejak 4b-3) — keempat rute `aset_meta.RUTE` kini punya halaman.
import DaftarAset from "@/pages/aset/DaftarAset";
import DetailAset from "@/pages/aset/DetailAset";
import JadwalMaintenance from "@/pages/aset/JadwalMaintenance";
import LaporanBulananAset from "@/pages/aset/LaporanBulananAset";
import InventarisOperasional from "@/pages/aset/InventarisOperasional";
import {
  PURCHASING_ROLES,
  VENDOR_FINANCE_ROLES,
  INVENTORY_SECTION_ROLES,
  INVENTORY_MATERIALS_ROLES,
  INVENTORY_LEDGER_ROLES,
  INVENTORY_ADJUSTMENT_ROLES,
  BARANG_BERKURANG_ROLES,
  PINDAH_BAHAN_ROLES,
  LAPORAN_BALIK_ROLES,
  PAYROLL_ROLES,
  UANG_MASUK_ROLES,
  KPI_ROLES,
  KARYAWAN_ROLES,
  ALARM_BAHAN_ROLES,
  ANALITIK_ROLES,
  INVENTORY_OPNAME_ROLES,
  INVENTORY_MATERIAL_ISSUE_ROLES,
  SPECIAL_OPS_ROLES,
  RECEIVABLE_NAV_ROLES,
  REFUND_NAV_ROLES,
  PDF_ARCHIVE_ROLES,
  PAPAN_KERJA_ROLES,
  JAM_MASUK_NAV_ROLES,
  WO_USUL_ROLES,
  PERCAKAPAN_ROLES,
  KANAL_WA_ROLES,
  BORONGAN_TULIS_ROLES,
  SERAH_TERIMA_CUSTOMER_ROLES,
  TINDAK_LANJUT_PESANAN_ROLES,
  BORONGAN_BACA_ROLES,
  ABSENSI_REKAP_ROLES,
  TRACKING_ROLES,
  LAPORAN_ROLES,
  PAPAN_KONTROL_ROLES,
  PAPAN_KONTROL_AMBANG_ROLES,
  FA_LAMA_ROLES,
  COMPLAINT_NAV_ROLES,
  SEMUA_PERAN,
  TANYA_ETAMS_REKAP_ROLES,
  CUSTOMER_ROLES,
  DR_READ_ROLES,
  DR_CREATE_ROLES,
  FA_DETAIL_ROLES,
  FA_CREATE_ROLES,
  FA_LIST_ROLES,
  WO_READ_ROLES,
  WO_WRITE_ROLES,
  SEWING_RATE_ROLES,
  SPV_REVIEW_ROLES,
  ASET_NAV_ROLES,
} from "@/lib/roles";

/**
 * Penanda route PUBLIK — tidak butuh sesi sama sekali.
 *
 * Murni penyataan maksud: ia merender anaknya apa adanya, nol logika. Gunanya
 * supaya route yang memang publik MENYATAKAN dirinya publik, bukan terlihat
 * publik karena kebetulan tidak dibungkus apa-apa. "Tidak dibungkus" tidak bisa
 * dibedakan dari "lupa dibungkus"; `<PublicRoute>` bisa.
 *
 * Dipakai hanya untuk route DI LUAR pembungkus sesi: /login, /auth/callback,
 * /hr/* (kios, sengaja tanpa login), dan catch-all.
 */
function PublicRoute({ children }) {
  return children;
}

/**
 * Pagar route. GAGAL-TERTUTUP sejak AKSES-03.
 *
 * Tiap route WAJIB menyatakan dirinya lewat salah satu dari empat penanda:
 * `roles`, `requireOwner`, `requireOwnerOrKepala`, atau `openToAllRoles`.
 * Route yang tidak menyatakan apa pun DITOLAK, bukan diloloskan.
 *
 * KENAPA. Sebelum ini, penjaganya berbunyi `if (roles && ...)`. Prop `roles`
 * yang hilang — atau yang bernilai `undefined` karena satu nama konstanta salah
 * ketik — membuat seluruh pemeriksaan DILEWATI, dan route terbuka untuk setiap
 * peran bersesi. `yarn build` tetap hijau saat itu terjadi: nama yang salah ketik
 * cuma jadi identifier tak terdefinisi, dan itu galat saat jalan, bukan saat
 * build. Jadi cacatnya tidak berbunyi di mana pun. Sekarang berbunyi.
 *
 * `openToAllRoles` sengaja berupa penanda tersendiri, bukan nilai bawaan.
 * Nilai bawaan bisa lahir dari kelalaian; penanda harus diketik. Itu bedanya
 * "route ini memang terbuka" dari "pagarnya lupa dipasang" — dua hal yang
 * sebelumnya terlihat sama persis di kode.
 */
function ProtectedRoute({ children, requireOwner, requireOwnerOrKepala, roles, openToAllRoles }) {
  const { loading, session, profile, isOwner, isKepalaCabang, roleCode, whitelistError } = useAuth();
  if (loading) return <div className="p-8 text-sm text-muted-foreground" data-testid="route-loading">Memuat...</div>;
  if (!session || !profile) {
    if (whitelistError) return <Navigate to="/auth/callback" replace />;
    // UAT7-T6-RELOAD-SISA-01: catat jejak lemparan (jam, halaman asal, nama kunci
    // sesi Supabase, hash OAuth) supaya kejadian "terlempar padahal sesi valid"
    // yang kedua punya bukti — gagal-diam, tidak mematahkan navigasi.
    catatLemparLogin({ session, profile, whitelistError });
    return <Navigate to="/login" replace />;
  }
  // GAGAL-TERTUTUP. Ditaruh SESUDAH pemeriksaan sesi supaya pengguna yang belum
  // login tetap dikirim ke /login, bukan ke /dashboard yang juga akan menolaknya.
  const menyatakanDiri =
    openToAllRoles === true ||
    requireOwner === true ||
    requireOwnerOrKepala === true ||
    Array.isArray(roles);
  if (!menyatakanDiri) {
    // Sengaja berisik. Route yang lupa menyatakan diri adalah cacat kode, dan
    // cacat kode yang tidak berbunyi akan hidup berbulan-bulan.
    console.error(
      "[ProtectedRoute] route ini tidak menyatakan hak aksesnya. " +
      "Wajib salah satu: prop roles (konstanta dari lib/roles.js) / requireOwner / requireOwnerOrKepala / openToAllRoles. " +
      "Akses DITOLAK. Penyebab tersering: nama konstanta salah ketik sehingga roles bernilai undefined."
    );
    return <Navigate to="/dashboard" replace />;
  }
  if (requireOwner && !isOwner) return <Navigate to="/dashboard" replace />;
  if (requireOwnerOrKepala && !isOwner && !isKepalaCabang) return <Navigate to="/dashboard" replace />;
  // Guard role generik (#4b-1): daftar role yang boleh membuka route ini.
  // Ini UX, BUKAN keamanan — otoritasnya tetap role guard + RLS backend.
  // Sebelumnya route purchasing bisa dibuka role apa pun lewat URL langsung
  // (termasuk Designer Editor yang blanket-403) dan layarnya pecah 403.
  if (roles && !roles.includes(roleCode)) return <Navigate to="/dashboard" replace />;
  return children;
}

function FAPlaceholder() { return null; }

function _AppRoutesImpl_unused() { return null; }

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/auth/callback" element={<PublicRoute><AuthCallback /></PublicRoute>} />
      {/*
        DOMAIN HR — dipasang SEKALI, tidak disentuh lagi. Layar HR baru
        cukup ditambahkan di frontend/src/routes/hrRoutes.js.

        ⚠ SENGAJA DI LUAR pembungkus <ProtectedRoute><Layout/></ProtectedRoute>
        di bawah, dan itu keputusan yang paling perlu dipahami di berkas ini:
        layar KIOS harus bisa dibuka TANPA login. Kios adalah perangkat
        BERSAMA yang dipakai bergantian puluhan karyawan — mengikatnya ke satu
        akun berarti absensi semua orang tercatat atas nama siapa pun yang
        kebetulan login terakhir, persis kebalikan dari yang absensi maksudkan.

        Yang menggantikan login di sana: token perangkat + PIN karyawan, dua-
        duanya diverifikasi BACKEND (kios tidak pernah memegang JWT).

        Rute HR yang BUKAN kios tetap butuh sesi — pagarnya di
        HRRoutesLoader per-rute (`publik: false`), bukan di sini, karena
        /hr/* memang tidak seragam. Konsekuensinya layar HR tidak memakai
        <Layout/> bersama; itu memang diinginkan untuk kios (layar penuh di
        perangkat kios, tanpa menu navigasi aplikasi).
      */}
      <Route
        path="/hr/*"
        element={
            <PublicRoute>
              <React.Suspense fallback={<div className="p-6 text-sm text-muted-foreground">Memuat…</div>}>
                <HRRoutesLoader />
              </React.Suspense>
            </PublicRoute>
        }
      />
      {/*
        DASHBOARD UMUM — layar TV ruang kerja. DI LUAR <Layout/>, tapi TETAP
        di dalam <ProtectedRoute>. Dua sifat itu sengaja dipisah:

        * TANPA <Layout/> — ia ditempel di TV ruang kerja dan dibaca dari
          beberapa meter. Menu navigasi memakan ruang yang dibutuhkan angka,
          dan nol ada yang akan mengkliknya dari seberang ruangan.

        * TETAP BUTUH LOGIN — dan ini yang membedakannya dari /hr/kios dan
          /r/{token}. Peringatan di blok Ruang Pesanan berbunyi "rute publik
          KETIGA adalah keputusan keamanan" — jadi ia SENGAJA nol jadi yang
          ketiga. TV-nya login sekali, lalu dibiarkan terbuka.

        * `openToAllRoles` — K190 butir 7 (BUSINESS-13, 22 Sep 2026): layar TV
          adalah SATU-SATUNYA route yang terbuka untuk semua peran bersesi,
          dan ISINYA DIBATASI (nomor, tahap, tenggat, jumlah — tanpa nama
          customer, telepon, harga, nilai FA) karena TV di bengkel terlihat
          kurir, tamu, dan customer yang lewat. Route lain menyebut perannya
          (cermin guard backend); test_open_to_all_roles_hanya_papan_tv
          menjaga keduanya.

        ⚠ Jalur lama `/papan-tv` DIPERTAHANKAN sebagai alias. TV yang sudah
          terpasang mungkin sudah menunjuk ke sana, dan mengganti URL berarti
          layar mati tanpa ada yang tahu sebabnya sampai seseorang lewat.
      */}
      <Route
        path="/dashboard-umum"
        element={<ProtectedRoute openToAllRoles><PapanTV /></ProtectedRoute>}
      />
      <Route
        path="/papan-tv"
        element={<ProtectedRoute openToAllRoles><PapanTV /></ProtectedRoute>}
      />
      {/*
        RUANG PESANAN — /r/{token}. SENGAJA DI LUAR <ProtectedRoute> dan di
        luar <Layout/>, dan dua-duanya keputusan, bukan kelalaian:

        * TANPA LOGIN — customer nol punya akun ETAMSIOS, dan nol akan pernah
          punya. Menuntut sesi berarti Ruang Pesanan nol pernah bisa dibuka
          siapa pun yang BERHAK membukanya. Yang menggantikan login: token
          rahasia di URL + 4 digit terakhir nomor HP (K124 butir 1), dua-
          duanya diverifikasi BACKEND. Layar ini nol pernah memegang JWT.

        * TANPA <Layout/> — Layout memasang menu navigasi aplikasi internal.
          Customer nol punya urusan dengan Inventory, Purchasing, atau Users,
          dan menampilkan menunya membocorkan bentuk sistem internal ke luar.

        ⚠ Ini rute publik KEDUA di aplikasi ini, sesudah /hr/kios. Kalau ada
        yang menambah rute publik KETIGA, itu keputusan keamanan — bawa ke
        Owner, jangan disalin karena "ruang pesanan juga begitu".
      */}
      {/* K226 (BUSINESS-104 B, keputusan Owner "104 setuju" 26 Okt 2026): tautan tim LIHAT-SAJA — rute publik yang
          diputuskan Owner. Tanpa 4 digit, tanpa tombol ubah; isinya dijepit server (tanpa harga/HP/alamat). */}
      <Route
        path="/r/tim/:kode"
        element={
          <PublicRoute>
            <React.Suspense fallback={<div className="p-6 text-sm text-muted-foreground">Memuat…</div>}>
              <RuangPesananTim />
            </React.Suspense>
          </PublicRoute>
        }
      />
      <Route
        path="/r/:token"
        element={
          <PublicRoute>
            <React.Suspense fallback={<div className="p-6 text-sm text-muted-foreground">Memuat…</div>}>
              <RuangPesanan />
            </React.Suspense>
          </PublicRoute>
        }
      />
      <Route
        element={
          <ProtectedRoute roles={SEMUA_PERAN}>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<ProtectedRoute roles={SEMUA_PERAN}><Dashboard /></ProtectedRoute>} />
        <Route path="/panduan" element={<ProtectedRoute roles={SEMUA_PERAN}><Panduan /></ProtectedRoute>} />
        <Route path="/tanya-etams/rekap" element={<ProtectedRoute roles={TANYA_ETAMS_REKAP_ROLES}><TanyaEtamsRekap /></ProtectedRoute>} />
        <Route path="/customers" element={<ProtectedRoute roles={CUSTOMER_ROLES}><Customers /></ProtectedRoute>} />
        <Route path="/customers/:id" element={<ProtectedRoute roles={CUSTOMER_ROLES}><CustomerDetail /></ProtectedRoute>} />
        <Route path="/design-requests" element={<ProtectedRoute roles={DR_READ_ROLES}><DesignRequests /></ProtectedRoute>} />
        <Route path="/design-requests/new" element={<ProtectedRoute roles={DR_CREATE_ROLES}><DesignRequestCreate /></ProtectedRoute>} />
        <Route path="/design-requests/:id" element={<ProtectedRoute roles={DR_READ_ROLES}><DesignRequestDetail /></ProtectedRoute>} />
        <Route path="/payments/pending" element={<ProtectedRoute requireOwnerOrKepala><PaymentsPending /></ProtectedRoute>} />
        <Route path="/fa-orders" element={<ProtectedRoute roles={FA_LIST_ROLES}><FAList /></ProtectedRoute>} />
        {/* FA Lama / cutover (langkah 33) — 14 Sep 2026. */}
        <Route path="/fa-lama" element={<ProtectedRoute roles={FA_LAMA_ROLES}><FaLama /></ProtectedRoute>} />
        <Route path="/fa-orders/new" element={<ProtectedRoute roles={FA_CREATE_ROLES}><FAWizard /></ProtectedRoute>} />
        <Route path="/fa-orders/:id" element={<ProtectedRoute roles={FA_DETAIL_ROLES}><FADetail /></ProtectedRoute>} />
        <Route path="/fa" element={<ProtectedRoute roles={SEMUA_PERAN}><Navigate to="/dashboard" replace /></ProtectedRoute>} />
        <Route path="/spv-review" element={<ProtectedRoute roles={SPV_REVIEW_ROLES}><SpvReview /></ProtectedRoute>} />
        <Route path="/design-tasks" element={<ProtectedRoute roles={DR_READ_ROLES}><DesignTasks /></ProtectedRoute>} />
        <Route path="/design-tasks/:id" element={<ProtectedRoute roles={DR_READ_ROLES}><DesignTaskDetail /></ProtectedRoute>} />
        <Route path="/master/price-groups" element={<ProtectedRoute requireOwnerOrKepala><MasterPriceGroups /></ProtectedRoute>} />
        <Route path="/master/price-list-items" element={<ProtectedRoute requireOwnerOrKepala><MasterPriceListItems /></ProtectedRoute>} />
        <Route path="/master/kategori-harga" element={<ProtectedRoute requireOwner><MasterKategoriHarga /></ProtectedRoute>} />
        <Route path="/master/kategori-komplain" element={<ProtectedRoute requireOwner><MasterKategoriKomplain /></ProtectedRoute>} />
        {/* T107: rekening resmi tujuan transfer per cabang — Owner menulis, Kepala Cabang melihat (backend menegakkan). */}
        <Route path="/master/rekening-resmi" element={<ProtectedRoute requireOwnerOrKepala><MasterRekeningResmi /></ProtectedRoute>} />
        {/* K207 W5: kunci alat AI per nomor WhatsApp + akun bot — Owner saja. */}
        <Route path="/master/kanal-wa" element={<ProtectedRoute requireOwner><MasterKanalWa /></ProtectedRoute>} />
        <Route path="/master/alasan/:jenis" element={<ProtectedRoute requireOwner><MasterAlasan /></ProtectedRoute>} />
        <Route path="/master/opsi-harga" element={<ProtectedRoute requireOwnerOrKepala><MasterOpsiHarga /></ProtectedRoute>} />
        <Route path="/master/size-surcharge" element={<ProtectedRoute requireOwnerOrKepala><MasterSizeSurcharge /></ProtectedRoute>} />
        <Route path="/master/collar" element={<ProtectedRoute requireOwnerOrKepala><MasterCollar /></ProtectedRoute>} />
        {/* Saklar notifikasi K19 — BACA untuk Owner/Kacab, UBAH hanya Owner
            (ditegakkan router, bukan rute ini). */}
        <Route path="/master/notification-channels" element={<ProtectedRoute requireOwnerOrKepala><MasterNotificationChannels /></ProtectedRoute>} />
        <Route path="/master/time-package" element={<ProtectedRoute requireOwnerOrKepala><MasterTimePackage /></ProtectedRoute>} />
        <Route path="/master/bonus-promo" element={<ProtectedRoute requireOwnerOrKepala><MasterBonusPromo /></ProtectedRoute>} />
        {/* K68 + K72 — FINANCE ikut membaca (READ-ONLY, ditegakkan komponennya
            sendiri + backend), OWNER/KEPALA_CABANG penuh. Bukan requireOwnerOrKepala. */}
        <Route path="/master/tarif-borongan" element={<ProtectedRoute roles={SEWING_RATE_ROLES}><MasterSewingRates /></ProtectedRoute>} />
        {/*
          PINTU MASUK LAYAR MASTER J2 — dipasang sekali, tidak disentuh lagi.

          Ditaruh SESUDAH keenam rute /master/... statis di atas. Urutannya
          sebenarnya tidak menentukan (React Router v7 memberi peringkat lebih
          tinggi pada segmen statis daripada splat, jadi keenamnya tetap
          menang atas `/master/*` di mana pun ia diletakkan) — tapi ditulis
          berurutan supaya pembaca berikutnya melihat maksudnya tanpa harus
          tahu aturan peringkat itu lebih dulu.

          `requireOwnerOrKepala` DISENGAJA SAMA dengan keenam rute di atas:
          seluruh layar master di masterRoutes.js mewarisi pagar ini, jadi J2
          tidak perlu (dan tidak boleh) mengurus hak akses per layar. Kalau
          kelak ada layar master yang butuh himpunan role berbeda, itu
          keputusan batas jalur — bawa ke Owner, jangan diselesaikan dengan
          menyunting App.js.
        */}
        <Route
          path="/master/*"
          element={
            <ProtectedRoute requireOwnerOrKepala>
              <MasterRoutesLoader />
            </ProtectedRoute>
          }
        />
        <Route path="/holidays" element={<ProtectedRoute requireOwnerOrKepala><Holidays /></ProtectedRoute>} />
        <Route path="/special-customers" element={<ProtectedRoute requireOwnerOrKepala><SpecialCustomers /></ProtectedRoute>} />
        <Route path="/foc-requests" element={<ProtectedRoute roles={SPECIAL_OPS_ROLES}><FocRequests /></ProtectedRoute>} />
        <Route path="/receivables" element={<ProtectedRoute roles={RECEIVABLE_NAV_ROLES}><Receivables /></ProtectedRoute>} />
        <Route path="/refunds" element={<ProtectedRoute roles={REFUND_NAV_ROLES}><Refunds /></ProtectedRoute>} />
        <Route path="/arsip-pdf" element={<ProtectedRoute roles={PDF_ARCHIVE_ROLES}><PdfArchive /></ProtectedRoute>} />
        <Route path="/papan-kerja" element={<ProtectedRoute roles={PAPAN_KERJA_ROLES}><PapanKerja /></ProtectedRoute>} />
        <Route path="/personil" element={<ProtectedRoute roles={PAPAN_KERJA_ROLES}><Personil /></ProtectedRoute>} />
        <Route path="/hrd/rekap-absensi" element={<ProtectedRoute roles={ABSENSI_REKAP_ROLES}><HRRekapAbsensi /></ProtectedRoute>} />
        <Route path="/hrd/karyawan" element={<ProtectedRoute roles={KARYAWAN_ROLES}><HRKaryawan /></ProtectedRoute>} />
        {/* Inventaris A17 — tiap orang bersesi boleh mengajukan untuk dirinya (Q37); hak memutus di backend. */}
        <Route path="/hrd/izin" element={<ProtectedRoute roles={SEMUA_PERAN}><HRPengajuanIzin /></ProtectedRoute>} />
        {/* Q37 koreksi lupa absen — tiap orang bersesi mengajukan untuk dirinya; hak memutus + rekap di backend. */}
        <Route path="/hrd/koreksi-absen" element={<ProtectedRoute roles={SEMUA_PERAN}><HRKoreksiAbsen /></ProtectedRoute>} />
        <Route path="/hrd/payroll" element={<ProtectedRoute roles={PAYROLL_ROLES}><HRPayroll /></ProtectedRoute>} />
        <Route path="/keuangan/uang-masuk" element={<ProtectedRoute roles={UANG_MASUK_ROLES}><UangMasuk /></ProtectedRoute>} />
        <Route path="/borongan/serah-terima" element={<ProtectedRoute roles={BORONGAN_TULIS_ROLES}><BoronganSerahTerima /></ProtectedRoute>} />
        {/* Serah terima ke CUSTOMER — tujuan scan label QR (`?fa=`). Lahir dari sensus pintu 23 Sep 2026. */}
        <Route path="/serah-terima" element={<ProtectedRoute roles={SERAH_TERIMA_CUSTOMER_ROLES}><SerahTerimaCustomer /></ProtectedRoute>} />
        <Route path="/tindak-lanjut-pesanan" element={<ProtectedRoute roles={TINDAK_LANJUT_PESANAN_ROLES}><TindakLanjutPesanan /></ProtectedRoute>} />
        <Route path="/borongan/rekap-upah" element={<ProtectedRoute roles={BORONGAN_BACA_ROLES}><BoronganRekapUpah /></ProtectedRoute>} />
        <Route path="/hrd/jam-masuk" element={<ProtectedRoute roles={JAM_MASUK_NAV_ROLES}><HRJamMasuk /></ProtectedRoute>} />
        <Route path="/tracking" element={<ProtectedRoute roles={TRACKING_ROLES}><TrackingPesanan /></ProtectedRoute>} />
        <Route path="/laporan" element={<ProtectedRoute roles={LAPORAN_ROLES}><Laporan /></ProtectedRoute>} />
        <Route path="/laporan/kpi" element={<ProtectedRoute roles={KPI_ROLES}><KpiKetepatan /></ProtectedRoute>} />
        <Route path="/laporan/analitik" element={<ProtectedRoute roles={ANALITIK_ROLES}><Analitik /></ProtectedRoute>} />
        <Route path="/papan-kontrol" element={<ProtectedRoute roles={PAPAN_KONTROL_ROLES}><PapanKontrol /></ProtectedRoute>} />
        <Route path="/papan-kontrol/ambang" element={<ProtectedRoute roles={PAPAN_KONTROL_AMBANG_ROLES}><PapanKontrolAmbang /></ProtectedRoute>} />
        <Route path="/percakapan" element={<ProtectedRoute roles={PERCAKAPAN_ROLES}><Percakapan /></ProtectedRoute>} />
        <Route path="/kanal-wa" element={<ProtectedRoute roles={KANAL_WA_ROLES}><KanalWhatsapp /></ProtectedRoute>} />
        <Route path="/complaints" element={<ProtectedRoute roles={COMPLAINT_NAV_ROLES}><Complaints /></ProtectedRoute>} />
        <Route path="/wo" element={<ProtectedRoute roles={WO_READ_ROLES}><WOList /></ProtectedRoute>} />
        <Route path="/wo/new" element={<ProtectedRoute roles={WO_WRITE_ROLES}><WOCreate /></ProtectedRoute>} />
        <Route path="/wo/usul" element={<ProtectedRoute roles={WO_USUL_ROLES}><WOUsulDraft /></ProtectedRoute>} />
        <Route path="/wo/:id" element={<ProtectedRoute roles={WO_READ_ROLES}><WODetail /></ProtectedRoute>} />
        {/* AKSES-01: tiap route Inventori memakai himpunan peran yang SAMA PERSIS
            dengan butir menunya di Layout.jsx. Sebelumnya kedelapannya polos, jadi
            peran yang menunya disembunyikan tetap sampai ke layar lewat URL langsung.
            Tiga route Barang Jadi memakai INVENTORY_SECTION_ROLES karena butir menunya
            memang tidak punya gate sendiri - terlihatnya ditentukan gate seksi Inventori.
            Ini UX, BUKAN keamanan: otoritasnya tetap role guard + RLS backend. */}
        <Route path="/inventory/materials" element={<ProtectedRoute roles={INVENTORY_MATERIALS_ROLES}><InvMaterials /></ProtectedRoute>} />
        <Route path="/inventory/material-issues" element={<ProtectedRoute roles={INVENTORY_MATERIAL_ISSUE_ROLES}><InvMaterialIssues /></ProtectedRoute>} />
        <Route path="/inventory/finished-goods" element={<ProtectedRoute roles={INVENTORY_SECTION_ROLES}><InvFinishedGoods /></ProtectedRoute>} />
        <Route path="/inventory/finished-goods/transfers" element={<ProtectedRoute roles={INVENTORY_SECTION_ROLES}><InvTransfers /></ProtectedRoute>} />
        <Route path="/inventory/stock/ledger" element={<ProtectedRoute roles={INVENTORY_LEDGER_ROLES}><InvStockLedger /></ProtectedRoute>} />
        <Route path="/inventory/adjustments" element={<ProtectedRoute roles={INVENTORY_ADJUSTMENT_ROLES}><InvAdjustments /></ProtectedRoute>} />
        {/* Celah 3 (langkah 35): satu layar approval barang berkurang — dibuka dari Penyesuaian Stok & Material Issue. */}
        <Route path="/inventory/barang-berkurang" element={<ProtectedRoute roles={BARANG_BERKURANG_ROLES}><BarangBerkurang /></ProtectedRoute>} />
        <Route path="/inventory/pindah-bahan" element={<ProtectedRoute roles={PINDAH_BAHAN_ROLES}><PindahBahan /></ProtectedRoute>} />
        <Route path="/inventory/stok-awal" element={<ProtectedRoute roles={INVENTORY_ADJUSTMENT_ROLES}><StokAwal /></ProtectedRoute>} />
        <Route path="/produksi/laporan-balik" element={<ProtectedRoute roles={LAPORAN_BALIK_ROLES}><LaporanBalik /></ProtectedRoute>} />
        <Route path="/inventory/telusur-lot" element={<ProtectedRoute roles={INVENTORY_SECTION_ROLES}><TelusurLot /></ProtectedRoute>} />
        <Route path="/inventory/alarm-bahan" element={<ProtectedRoute roles={ALARM_BAHAN_ROLES}><AlarmBahan /></ProtectedRoute>} />
        <Route path="/inventory/opname" element={<ProtectedRoute roles={INVENTORY_OPNAME_ROLES}><InvOpname /></ProtectedRoute>} />
        <Route path="/inventory/finished-goods/movements" element={<ProtectedRoute roles={INVENTORY_SECTION_ROLES}><InvFGMovement /></ProtectedRoute>} />
        <Route path="/purchasing/vendors" element={<ProtectedRoute roles={PURCHASING_ROLES}><PurVendors /></ProtectedRoute>} />
        <Route path="/purchasing/pr" element={<ProtectedRoute roles={PURCHASING_ROLES}><PurPRs /></ProtectedRoute>} />
        <Route path="/purchasing/pr/:id" element={<ProtectedRoute roles={PURCHASING_ROLES}><PurPRDetail /></ProtectedRoute>} />
        <Route path="/purchasing/po" element={<ProtectedRoute roles={PURCHASING_ROLES}><PurPOs /></ProtectedRoute>} />
        <Route path="/purchasing/po/:id" element={<ProtectedRoute roles={PURCHASING_ROLES}><PurPODetail /></ProtectedRoute>} />
        <Route path="/purchasing/receiving" element={<ProtectedRoute roles={PURCHASING_ROLES}><PurReceiving /></ProtectedRoute>} />
        <Route path="/purchasing/returns" element={<ProtectedRoute roles={PURCHASING_ROLES}><PurReturns /></ProtectedRoute>} />
        {/* Urutan penting: /invoices/new WAJIB di atas /invoices/:id, kalau
            tidak "new" akan ditangkap sebagai id lalu jadi 404. */}
        <Route path="/purchasing/invoices" element={<ProtectedRoute roles={VENDOR_FINANCE_ROLES}><PurInvoices /></ProtectedRoute>} />
        <Route path="/purchasing/invoices/new" element={<ProtectedRoute roles={VENDOR_FINANCE_ROLES}><PurInvoiceCreate /></ProtectedRoute>} />
        <Route path="/purchasing/invoices/:id" element={<ProtectedRoute roles={VENDOR_FINANCE_ROLES}><PurInvoiceDetail /></ProtectedRoute>} />
        {/* Riwayat pembayaran (#4b-3b). Tidak ada route /payments/:id —
            detailnya panel di halaman yang sama, dibuka lewat ?open=<id>
            supaya tautannya tetap bisa dibagikan. */}
        <Route path="/purchasing/payments" element={<ProtectedRoute roles={VENDOR_FINANCE_ROLES}><PurPayments /></ProtectedRoute>} />
        {/* Uang muka vendor (#4b-3c). DP_READ_ROLES di backend berisi 4 role
            yang sama dengan invoice/payment — uang muka adalah uang keluar,
            cakupan pembacanya identik. Tidak ada /dp/new: pengajuan berupa
            dialog di layar daftar, dibuka dari sana maupun dari panel PO
            lewat ?po_id=<id>. */}
        <Route path="/purchasing/dp" element={<ProtectedRoute roles={VENDOR_FINANCE_ROLES}><PurDPs /></ProtectedRoute>} />
        <Route path="/purchasing/dp/:id" element={<ProtectedRoute roles={VENDOR_FINANCE_ROLES}><PurDPDetail /></ProtectedRoute>} />
        {/* Aset & Maintenance (L1–L3, 4b-1). ASET_NAV_ROLES = cermin
            `aset_meta.MENU.jabatan` (L2) — sama persis dengan gerbang kelompok
            menu "Aset" di Layout.jsx. UX, bukan keamanan: `_lingkup_baca`
            backend yang menolak FINANCE/PURCHASING/desainer tanpa aset.
            ⚠ `/aset/jadwal` dan `/aset/laporan-bulanan` WAJIB di atas `/aset/:id` —
            kalau tidak, segmen itu ditangkap sebagai id dan layarnya 404. */}
        <Route path="/aset" element={<ProtectedRoute roles={ASET_NAV_ROLES}><DaftarAset /></ProtectedRoute>} />
        <Route path="/aset/jadwal" element={<ProtectedRoute roles={ASET_NAV_ROLES}><JadwalMaintenance /></ProtectedRoute>} />
        <Route path="/aset/laporan-bulanan" element={<ProtectedRoute roles={ASET_NAV_ROLES}><LaporanBulananAset /></ProtectedRoute>} />
        {/* U33b inventaris operasional Q170–Q172 — dibuka dari Daftar Aset (jumlah menu sidebar dikunci Owner 24 Sep). */}
        <Route path="/aset/inventaris" element={<ProtectedRoute roles={ASET_NAV_ROLES}><InventarisOperasional /></ProtectedRoute>} />
        <Route path="/aset/:id" element={<ProtectedRoute roles={ASET_NAV_ROLES}><DetailAset /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute requireOwner><Users /></ProtectedRoute>} />
        {/* HPP/margin: HANYA Owner — konstitusi, bukan selera (P3 K139). */}
        <Route path="/hpp" element={<ProtectedRoute requireOwner><Hpp /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute requireOwner><Settings /></ProtectedRoute>} />
        <Route path="/audit-logs" element={<ProtectedRoute requireOwnerOrKepala><AuditLogs /></ProtectedRoute>} />
        {/* K140 butir 6 — Owner saja (cermin require_owner). Lahir dari sensus pintu 23 Sep 2026. */}
        <Route path="/audit-logs/tinjauan-delegasi" element={<ProtectedRoute requireOwner><TinjauanDelegasi /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<PublicRoute><Navigate to="/dashboard" replace /></PublicRoute>} />
    </Routes>
  );
}

// Toaster harus sadar tema (K2 — notifikasi seragam di kedua mode).
// Sebelumnya <Toaster> dipasang tanpa prop theme → tetap terang di mode gelap.
function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster position="top-right" richColors theme={theme} />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
            <ThemedToaster />
            <DialogAplikasi />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
